var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 150.92653,
    viewBox: "0 0 440.89 332.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_path_0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.27,65.44l-7.28,4.27l4,1l-1.33,22.34l-19.01,10.97l0,-44.91l25.93,-14.97l0,19.96l-2.3,1.33z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m82.33,296.39c82.03,48.42 215.02,48.43 297.04,0 82.03,-48.43 82.03,-126.94 0,-175.36 -82.03,-48.42 -215.02,-48.42 -297.04,-0 -82.03,48.42 -82.03,126.94 0,175.36Z",
    strokeWidth: 0,
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#27debf",
    d: "m403.02,117.47c0.45,-5.62 4.78,-15.2 11.19,-22.02 6.41,-6.82 16.67,-10.11 23,-7.36 5.89,2.56 4.6,10.46 -3.18,15.14 -7.78,4.68 -19.37,10.41 -23.33,19.26l-7.68,10.63v-15.65Z",
    strokeWidth: 0,
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000FF",
    fillOpacity: 0.2,
    d: "m403.02,117.47c0.45,-5.62 4.78,-15.2 11.19,-22.02 6.41,-6.82 16.67,-10.11 23,-7.36 5.89,2.56 4.6,10.46 -3.18,15.14 -7.78,4.68 -19.37,10.41 -23.33,19.26l-7.68,10.63v-15.65Z",
    strokeOpacity: 0.2,
    strokeWidth: 0,
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m434.74,90.74c-7.35,1.4 -28.9,15.26 -31.72,36.21",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1,
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#27debf",
    d: "m403.86,142.75c1.16,-3.08 6.06,-8.62 13.15,-11.35 7.09,-2.73 12.42,-5.17 14.97,-9.57 2.55,-4.4 -1.9,-8.72 -9.06,-8.41 -7.16,0.31 -19.05,7.8 -19.9,19.7l0.84,9.63Z",
    strokeWidth: 0,
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m426.57,116.99c-6.18,0.61 -21.2,9.72 -23.23,19.92",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1,
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#27debf",
    d: "m34.49,171.26s0.05,-10.56 -5.21,-23.06c-5.27,-12.5 -15.93,-19.1 -21.6,-20.03 -5.67,-0.92 -11.55,5.97 -4.32,14.2 7.23,8.23 21.09,19.17 25.06,35.79l6.51,11.34 -0.43,-18.24Z",
    strokeWidth: 0,
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000FF",
    fillOpacity: 0.2,
    d: "m34.49,171.26s0.05,-10.56 -5.21,-23.06c-5.27,-12.5 -15.93,-19.1 -21.6,-20.03 -5.67,-0.92 -11.55,5.97 -4.32,14.2 7.23,8.23 21.09,19.17 25.06,35.79l6.51,11.34 -0.43,-18.24Z",
    strokeOpacity: 0.2,
    strokeWidth: 0,
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m7.68,132.01c11.65,6.94 25.17,25.15 27.06,49.35",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#27debf",
    d: "m33.6,201.15c-1.57,-6.41 -5.82,-12.74 -14.23,-19.06 -8.41,-6.32 -19.65,-11.74 -18.73,-18.2s9.44,-6 15.68,-3.15c6.24,2.85 17.06,14.58 18.61,28.76l-1.33,11.65Z",
    strokeWidth: 0,
    id: "path_9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m6.55,161.88c8.1,2.02 25.48,17.89 27.95,31.44",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m35.9,205.14c-1.27,-0.73 -2.3,-2.52 -2.3,-3.99V56.79c0,-1.47 1.03,-3.26 2.3,-3.99l51.56,-29.77c1.27,-0.73 3.27,-0.77 4.46,-0.08s2.16,2.44 2.16,3.91v9.65c0,1.47 1.03,2.06 2.3,1.33L160.93,0.58c1.27,-0.73 3.27,-0.77 4.46,-0.08 1.19,0.69 2.16,2.44 2.16,3.91v221.87l-47.53,27.44 -84.12,-48.56Z",
    strokeWidth: 0,
    id: "path_11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m165.39,0.49c-1.19,-0.69 -3.19,-0.65 -4.46,0.08l-64.53,37.26c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-9.65c0,-1.47 -0.97,-3.22 -2.16,-3.91 -1.19,-0.69 -3.19,-0.65 -4.46,0.08l-51.56,29.77c-0.64,0.37 -1.21,1 -1.63,1.72l29.57,17.07L167.55,11.72v-7.32c0,-1.47 -0.97,-3.22 -2.16,-3.91Z",
    strokeWidth: 0,
    id: "path_12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "m165.25,3.07l-68.85,39.75c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-14.64c0,-1.47 -1.03,-2.06 -2.3,-1.33l-51.57,29.77c-1.27,0.73 -2.3,2.52 -2.3,3.99l0,139.38c0,1.47 1.03,3.26 2.3,3.99l84.11,48.56 43.21,-24.95V4.4c0,-1.47 -1.03,-2.06 -2.3,-1.33Z",
    strokeWidth: 0,
    id: "path_13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m38.6,200.93c0.42,0.72 0.99,1.35 1.63,1.72l84.11,48.56 43.21,-24.95v-99.79L38.6,200.93Z",
    strokeWidth: 0,
    id: "path_14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "m49.04,232.68l-0.64,-0.37c-1.02,-0.59 -1.84,-2.02 -1.84,-3.19V93.68c0,-1.17 0.82,-2.6 1.84,-3.19L187.31,10.29c1.02,-0.59 2.67,-0.59 3.68,0l0.64,0.37c1.02,0.59 1.84,2.02 1.84,3.19v135.45c0,1.17 -0.82,2.6 -1.84,3.19L52.73,232.68c-1.02,0.59 -2.67,0.59 -3.68,0Z",
    strokeWidth: 0,
    id: "path_15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m55.21,96.54l-8.1,-4.68c-0.33,0.58 -0.54,1.23 -0.54,1.82v135.45c0,1.17 0.83,2.6 1.84,3.19l0.64,0.37c1.02,0.59 2.67,0.59 3.68,0l2.48,-1.43V96.54Z",
    strokeWidth: 0,
    id: "path_16"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "m50.89,231.62V96.17c0,-1.17 0.82,-2.6 1.84,-3.19L191.63,12.78c1.02,-0.59 1.84,-0.11 1.84,1.06v135.45c0,1.17 -0.82,2.6 -1.84,3.19L52.73,232.68c-1.02,0.59 -1.84,0.11 -1.84,-1.06Z",
    strokeWidth: 0,
    id: "path_17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m61.83,97.7L182.53,28.01c1.27,-0.73 2.3,-0.14 2.3,1.33v104.45c0,1.47 -1.03,3.26 -2.3,3.99l-120.7,69.69c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-104.45c0,-1.47 1.03,-3.26 2.3,-3.99Z",
    strokeWidth: 0,
    id: "path_18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m81.78,92.5c7.52,-4.34 13.61,-0.82 13.61,7.86 0,8.68 -6.09,19.23 -13.61,23.57 -7.52,4.34 -13.61,0.82 -13.61,-7.86s6.09,-19.23 13.61,-23.57Z",
    strokeWidth: 0,
    id: "path_19"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m94.39,123.98c1.99,-3.7 7,-4.39 9.91,-1.36l15.71,16.33 29.8,-73.11c1.94,-4.77 8.52,-5.22 11.1,-0.76l23.92,41.44v27.28c-0,1.47 -1.03,3.26 -2.3,3.99l-120.7,69.69c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-17.3s34.86,-64.86 34.86,-64.86Z",
    strokeWidth: 0,
    id: "path_20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "m74.97,247.66l-0.64,-0.37c-1.02,-0.59 -1.84,-2.02 -1.84,-3.19V108.65c0,-1.17 0.82,-2.6 1.84,-3.19L213.24,25.26c1.02,-0.59 2.67,-0.59 3.68,0l0.64,0.37c1.02,0.59 1.84,2.02 1.84,3.19v135.45c0,1.17 -0.82,2.6 -1.84,3.19l-138.91,80.2c-1.02,0.59 -2.67,0.59 -3.68,0Z",
    strokeWidth: 0,
    id: "path_21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m81.13,111.51l-8.1,-4.68c-0.33,0.58 -0.54,1.23 -0.54,1.82v135.45c0,1.17 0.83,2.6 1.84,3.19l0.64,0.37c1.02,0.59 2.67,0.59 3.68,0l2.48,-1.43V111.51Z",
    strokeWidth: 0,
    id: "path_22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "m76.81,246.6V111.15c0,-1.17 0.82,-2.6 1.84,-3.19L217.56,27.76c1.02,-0.59 1.84,-0.11 1.84,1.06v135.45c0,1.17 -0.82,2.6 -1.84,3.19l-138.91,80.2c-1.02,0.59 -1.84,0.11 -1.84,-1.06Z",
    strokeWidth: 0,
    id: "path_23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m87.76,112.68l120.7,-69.69c1.27,-0.73 2.3,-0.14 2.3,1.33v104.45c0,1.47 -1.03,3.26 -2.3,3.99l-120.7,69.69c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-104.45c0,-1.47 1.03,-3.26 2.3,-3.99Z",
    strokeWidth: 0,
    id: "path_24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m107.71,107.48c7.52,-4.34 13.61,-0.82 13.61,7.86 0,8.68 -6.09,19.23 -13.61,23.57 -7.52,4.34 -13.61,0.82 -13.61,-7.86s6.09,-19.23 13.61,-23.57Z",
    strokeWidth: 0,
    id: "path_25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m120.32,138.96c1.99,-3.7 7,-4.39 9.91,-1.36l15.71,16.33 29.8,-73.11c1.94,-4.77 8.52,-5.22 11.1,-0.76l23.92,41.44v27.28c-0,1.47 -1.03,3.26 -2.3,3.99l-120.7,69.69c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-17.3s34.86,-64.86 34.86,-64.86Z",
    strokeWidth: 0,
    id: "path_26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "m100.89,262.62l-0.64,-0.37c-1.02,-0.59 -1.84,-2.02 -1.84,-3.19V123.61c0,-1.17 0.82,-2.6 1.84,-3.19L239.16,40.22c1.02,-0.59 2.67,-0.59 3.68,0l0.64,0.37c1.02,0.59 1.84,2.02 1.84,3.19v135.45c0,1.17 -0.82,2.6 -1.84,3.19l-138.91,80.2c-1.02,0.59 -2.67,0.59 -3.68,0Z",
    strokeWidth: 0,
    id: "path_27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m107.06,126.48l-8.1,-4.68c-0.33,0.58 -0.54,1.23 -0.54,1.82v135.45c0,1.17 0.83,2.6 1.84,3.19l0.64,0.37c1.02,0.59 2.67,0.59 3.68,0l2.48,-1.43V126.48Z",
    strokeWidth: 0,
    id: "path_28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "m102.74,261.56V126.11c0,-1.17 0.82,-2.6 1.84,-3.19L243.49,42.72c1.02,-0.59 1.84,-0.11 1.84,1.06v135.45c0,1.17 -0.82,2.6 -1.84,3.19l-138.91,80.2c-1.02,0.59 -1.84,0.11 -1.84,-1.06Z",
    strokeWidth: 0,
    id: "path_29"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m113.68,127.64l120.7,-69.69c1.27,-0.73 2.3,-0.14 2.3,1.33v104.45c0,1.47 -1.03,3.26 -2.3,3.99l-120.7,69.69c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-104.45c0,-1.47 1.03,-3.26 2.3,-3.99Z",
    strokeWidth: 0,
    id: "path_30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m133.63,122.44c7.52,-4.34 13.61,-0.82 13.61,7.86 0,8.68 -6.09,19.23 -13.61,23.57 -7.52,4.34 -13.61,0.82 -13.61,-7.86s6.09,-19.23 13.61,-23.57Z",
    strokeWidth: 0,
    id: "path_31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m146.24,153.92c1.99,-3.7 7,-4.39 9.91,-1.36l15.71,16.33 29.8,-73.11c1.94,-4.77 8.52,-5.22 11.1,-0.76l23.92,41.44v27.28c-0,1.47 -1.03,3.26 -2.3,3.99l-120.7,69.69c-1.27,0.73 -2.3,0.14 -2.3,-1.33v-17.3s34.86,-64.86 34.86,-64.86Z",
    strokeWidth: 0,
    id: "path_32"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M124.34,251.21l12.96,-7.48l0,14.97l-12.96,-7.48z",
    strokeWidth: 0,
    id: "path_33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m137.3,146.6v109.44c0,1.47 -1.03,2.06 -2.3,1.33l-10.66,-6.15 -4.32,2.49 19.3,11.14c1.27,0.73 3.33,0.73 4.61,0l133.66,-77.17c1.27,-0.73 2.3,-2.52 2.3,-3.99v-114.43c0,-1.47 -0.97,-3.22 -2.16,-3.91 -1.19,-0.69 -3.19,-0.65 -4.46,0.08l-133.66,77.17c-1.27,0.73 -2.3,2.52 -2.3,3.99Z",
    strokeWidth: 0,
    id: "path_34"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m145.95,148.93l133.95,-77.34v-2.33c0,-1.47 -0.97,-3.22 -2.16,-3.91 -1.19,-0.69 -3.19,-0.65 -4.46,0.08l-133.66,77.17c-0.64,0.37 -1.21,1 -1.63,1.72l7.97,4.6Z",
    strokeWidth: 0,
    id: "path_35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "m277.59,67.93l-133.66,77.17c-1.27,0.73 -2.3,2.52 -2.3,3.99v114.43c0,1.47 1.03,2.06 2.3,1.33l133.66,-77.17c1.27,-0.73 2.3,-2.52 2.3,-3.99v-114.43c0,-1.47 -1.03,-2.06 -2.3,-1.33Z",
    strokeWidth: 0,
    id: "path_36"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m177.21,215.98c-0.26,0 -0.51,-0.06 -0.73,-0.19 -0.51,-0.29 -0.79,-0.87 -0.79,-1.63v-55.62c0,-1.36 0.92,-2.95 2.09,-3.62l65.45,-37.79c0.65,-0.38 1.29,-0.42 1.8,-0.13 0.51,0.29 0.79,0.87 0.79,1.63v55.62c0,1.36 -0.92,2.95 -2.09,3.62l-65.45,37.79c-0.37,0.21 -0.73,0.32 -1.07,0.32ZM244.31,117.81c-0.16,0 -0.36,0.06 -0.57,0.19l-65.45,37.79h0c-0.86,0.5 -1.59,1.76 -1.59,2.76v55.62c0,0.38 0.1,0.65 0.29,0.76 0.18,0.1 0.48,0.06 0.8,-0.13l65.45,-37.79c0.86,-0.5 1.59,-1.76 1.59,-2.76v-55.62c0,-0.38 -0.11,-0.65 -0.29,-0.76 -0.06,-0.04 -0.14,-0.06 -0.23,-0.06ZM178.04,155.35h0.01,-0.01Z",
    strokeWidth: 0,
    id: "path_37"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m187.76,168.08c-0.59,0 -1.14,-0.14 -1.63,-0.42 -1.16,-0.67 -1.8,-2.04 -1.8,-3.86 0,-3.53 2.48,-7.83 5.54,-9.59 1.57,-0.91 3.08,-1.04 4.24,-0.37 1.16,0.67 1.8,2.04 1.8,3.86 0,3.53 -2.48,7.83 -5.54,9.59 -0.91,0.53 -1.8,0.79 -2.61,0.79ZM192.48,154.42c-0.63,0 -1.35,0.22 -2.11,0.66 -2.78,1.6 -5.04,5.52 -5.04,8.73 0,1.45 0.46,2.51 1.3,2.99 0.84,0.48 1.99,0.35 3.24,-0.37 2.78,-1.6 5.04,-5.52 5.04,-8.73 0,-1.45 -0.46,-2.51 -1.3,-2.99 -0.33,-0.19 -0.71,-0.29 -1.13,-0.29Z",
    strokeWidth: 0,
    id: "path_38"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m176.19,211.8c-0.08,0 -0.15,-0.02 -0.23,-0.05 -0.25,-0.13 -0.34,-0.43 -0.22,-0.67l19.39,-38.05c0.6,-1.18 1.69,-1.98 2.99,-2.2 1.3,-0.22 2.59,0.18 3.54,1.1l19.16,18.44c0.2,0.19 0.2,0.51 0.01,0.71 -0.19,0.2 -0.51,0.2 -0.71,0.01l-19.16,-18.44c-0.72,-0.69 -1.7,-0.99 -2.68,-0.83 -0.99,0.17 -1.81,0.77 -2.27,1.66l-19.39,38.05c-0.09,0.17 -0.26,0.27 -0.45,0.27Z",
    strokeWidth: 0,
    id: "path_39"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m210.76,181.86c-0.07,0 -0.13,-0.01 -0.2,-0.04 -0.25,-0.11 -0.37,-0.4 -0.26,-0.66l15.01,-34.67c0.56,-1.29 1.72,-2.17 3.11,-2.37 1.39,-0.2 2.75,0.33 3.65,1.41l13.64,16.49c0.18,0.21 0.14,0.53 -0.07,0.7 -0.21,0.17 -0.53,0.15 -0.7,-0.07l-13.64,-16.49c-0.67,-0.81 -1.69,-1.21 -2.73,-1.06 -1.04,0.15 -1.91,0.81 -2.33,1.78l-15.01,34.67c-0.08,0.19 -0.27,0.3 -0.46,0.3Z",
    strokeWidth: 0,
    id: "path_40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27debf",
    d: "m259.85,93.3c-3.08,0 -5.15,-1.85 -5.15,-4.6l0.27,-17.34c0,-4.73 0,-11.91 5.28,-14.96 2.46,-1.42 5.18,-1.48 7.46,-0.16 2.22,1.28 3.6,3.68 3.6,6.27 0,1.39 -0.04,3.1 -0.12,5.06 -0.04,0.83 -0.7,1.47 -1.56,1.44 -0.83,-0.03 -1.47,-0.73 -1.44,-1.56 0.08,-1.9 0.12,-3.61 0.12,-4.94 0,-1.52 -0.81,-2.92 -2.1,-3.67 -0.78,-0.45 -2.4,-1.03 -4.46,0.16 -3.49,2.01 -3.78,7.01 -3.78,12.38l-0.27,17.34c0,1.3 1.17,1.57 2.15,1.57 2.58,0 6.14,-2.16 6.14,-6.23l-0.11,-6.84c-0.01,-0.83 0.65,-1.51 1.48,-1.52 0.82,0 1.51,0.65 1.52,1.48l0.11,6.87c0,5.72 -4.75,9.25 -9.15,9.25Z",
    strokeWidth: 0,
    clipPath: "url(#clip_path_0)"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m282.38,199.89l-104.34,60.24c-1.02,0.59 -1.84,2.02 -1.84,3.19v0.73c0,1.17 0.82,2.6 1.84,3.19l87.06,50.26c1.02,0.59 2.67,0.59 3.68,0l104.34,-60.24c1.02,-0.59 1.84,-2.02 1.84,-3.19v-0.73c0,-1.17 -0.82,-2.6 -1.84,-3.19l-87.06,-50.26c-1.02,-0.59 -2.67,-0.59 -3.68,0Z",
    strokeWidth: 0,
    id: "path_41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m176.19,263.32v0.73c0,1.17 0.82,2.6 1.84,3.19l87.06,50.26c0.51,0.29 1.17,0.44 1.84,0.44v-9.36s-86.42,-49.89 -86.42,-49.89l-2.48,1.43c-1.02,0.59 -1.84,2.02 -1.84,3.19Z",
    strokeWidth: 0,
    id: "path_42"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "m178.04,260.13l104.34,-60.24c1.02,-0.59 2.67,-0.59 3.68,0l87.06,50.26c1.02,0.59 1.02,1.54 0,2.13l-104.34,60.24c-1.02,0.59 -2.67,0.59 -3.68,0l-87.06,-50.26c-1.02,-0.59 -1.02,-1.54 0,-2.13Z",
    strokeWidth: 0,
    id: "path_43"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m191,262.25l67.61,39.03c1.02,0.59 2.67,0.59 3.68,0l91.38,-52.76c1.02,-0.59 1.02,-1.54 0,-2.13l-67.61,-39.04c-1.02,-0.59 -2.67,-0.59 -3.68,0l-91.38,52.76c-1.02,0.59 -1.02,1.54 0,2.13Z",
    strokeWidth: 0,
    id: "path_44"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m211.84,254.01c4.77,-2.76 12.51,-2.76 17.28,0 4.77,2.76 4.77,7.22 0,9.98 -4.77,2.76 -12.51,2.76 -17.28,0 -4.77,-2.76 -4.77,-7.22 0,-9.98Z",
    strokeWidth: 0,
    id: "path_45"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m353.67,246.41l-19.76,-11.41 -60.01,-5.59c-3.18,-0.3 -5.55,2.88 -4.37,5.85l10.37,25.94 -33.03,-1.89c-2.74,-0.16 -4.91,2.27 -4.46,4.97l5.08,30.6h0l11.12,6.42c1.02,0.59 2.67,0.59 3.68,0l91.38,-52.76c1.02,-0.59 1.02,-1.54 0,-2.13Z",
    strokeWidth: 0,
    id: "path_46"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M353.35,173.88l0,-39.92l51.85,-29.94l0,39.92l-51.85,29.94z",
    strokeWidth: 0,
    id: "path_47"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M353.35,133.96l-64.82,-37.42l0,39.92l64.82,37.42l0,-39.92z",
    strokeWidth: 0,
    id: "path_48"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M353.35,133.96l53.39,-30.84l-66.35,-38.32l-53.39,30.84l66.35,38.32z",
    strokeWidth: 0,
    id: "path_49"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M353.35,133.96l0,9.98l53.39,-30.82l0,-9.99l-53.39,30.84z",
    strokeWidth: 0,
    id: "path_50"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M353.35,143.94l51.85,-29.94l0,2.19l-51.85,29.94l0,-2.19z",
    strokeWidth: 0,
    id: "path_51"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M287,95.64l66.35,38.32l0,9.98l-66.35,-38.31l0,-9.99z",
    strokeWidth: 0,
    id: "path_52"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    fillOpacity: 0.5,
    d: "M353.35,143.94l-64.82,-37.42l0,2.19l64.81,37.42l0,-2.19z",
    strokeOpacity: 0.5,
    strokeWidth: 0,
    id: "path_53"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m370.42,140.03l17.71,-10.23c0.76,-0.44 1.38,-0.08 1.38,0.8v10.47c0,0.88 -0.62,1.95 -1.38,2.39l-17.71,10.23c-0.76,0.44 -1.38,0.08 -1.38,-0.8v-10.47c0,-0.88 0.62,-1.95 1.38,-2.39Z",
    strokeWidth: 0,
    id: "path_54"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m371.55,141.21l15.44,-8.92c0.51,-0.29 0.92,-0.06 0.92,0.53v7.85c0,0.59 -0.41,1.3 -0.92,1.6l-15.44,8.91c-0.51,0.29 -0.92,0.06 -0.92,-0.53v-7.85c0,-0.59 0.41,-1.3 0.92,-1.6Z",
    strokeWidth: 0,
    id: "path_55"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M353.35,128.94l0,-39.92l51.85,-29.94l0,39.92l-51.85,29.94z",
    strokeWidth: 0,
    id: "path_56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M353.35,89.03l-64.82,-37.42l0,39.92l64.82,37.42l0,-39.92z",
    strokeWidth: 0,
    id: "path_57"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M353.35,89.03l53.39,-30.84l-66.35,-38.32l-53.39,30.84l66.35,38.32z",
    strokeWidth: 0,
    id: "path_58"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M353.35,89.03l0,9.98l53.39,-30.82l0,-9.99l-53.39,30.84z",
    strokeWidth: 0,
    id: "path_59"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M353.35,99.01l51.85,-29.94l0,2.19l-51.85,29.94l0,-2.19z",
    strokeWidth: 0,
    id: "path_60"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M287,50.71l66.35,38.32l0,9.98l-66.35,-38.31l0,-9.99z",
    strokeWidth: 0,
    id: "path_61"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    fillOpacity: 0.5,
    d: "M353.35,99.01l-64.82,-37.42l0,2.19l64.81,37.42l0,-2.19z",
    strokeOpacity: 0.5,
    strokeWidth: 0,
    id: "path_62"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m370.42,95.1l17.71,-10.23c0.76,-0.44 1.38,-0.08 1.38,0.8v10.47c0,0.88 -0.62,1.95 -1.38,2.39l-17.71,10.23c-0.76,0.44 -1.38,0.08 -1.38,-0.8v-10.47c0,-0.88 0.62,-1.95 1.38,-2.39Z",
    strokeWidth: 0,
    id: "path_63"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m371.55,96.28l15.44,-8.92c0.51,-0.29 0.92,-0.06 0.92,0.53v7.85c0,0.59 -0.41,1.3 -0.92,1.6l-15.44,8.91c-0.51,0.29 -0.92,0.06 -0.92,-0.53v-7.85c0,-0.59 0.41,-1.3 0.92,-1.6Z",
    strokeWidth: 0,
    id: "path_64"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M402.4,100.62l-49.05,28.32l-62.02,-35.82l-1.52,0.9l63.54,36.56l50.58,-29.07l-1.52,-0.88z",
    strokeWidth: 0,
    id: "path_65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFile);
export default __webpack_public_path__ + "static/media/no_file.f7eef5753712bc50acfe46e6a4ec13e2.svg";
export { ForwardRef as ReactComponent };